import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import customworkspace1 from "../../../../assets/images/docs/customworkspace1.png";
import customworkspace2 from "../../../../assets/images/docs/customworkspace2.png";
import sortingWorkspaces from "../../../../assets/videos/docs/workspaces/sorting-workspaces.mp4";
import * as React from 'react';
export default {
  ShortCutDisplay,
  customworkspace1,
  customworkspace2,
  sortingWorkspaces,
  React
};